import { jsx, jsxs } from 'react/jsx-runtime';
import paymentCardConstants from '../../../constants/paymentCardConstants.js';
import { containerStyle, fieldsetStyle, radioLabel } from '../styles.js';
var StubbedCardSelector = function StubbedCardSelector(_ref) {
  var stubbedCard = _ref.stubbedCard,
    _onChange = _ref.onChange;
  return jsx("div", {
    style: containerStyle,
    children: jsxs("fieldset", {
      style: fieldsetStyle,
      children: [jsx("legend", {
        children: "Stubbed card options:"
      }), Object.values(paymentCardConstants).map(function (card) {
        return jsxs("label", {
          style: radioLabel,
          children: [jsx("input", {
            type: "radio",
            name: "stubbedCard",
            value: card.number,
            checked: stubbedCard === card.number,
            onChange: function onChange() {
              return _onChange(card.number);
            }
          }), card.label]
        }, card.number);
      })]
    })
  });
};
export { StubbedCardSelector as default };